import moment from 'moment'
import { month, week, periodEnum, period } from '../DataExport/common'
const format = require('string-format')

export function returnScheduleListValue(ScheduleRecurrenceList, ScheduleReportList, label, UserPreference_response) {
  var EffectiveDaysList = []
  var FormatedTime
  var index_Array = EffectiveDaysList.map(el => parseInt(el.id))
  let maxid = EffectiveDaysList.length === 0 ? 0 : Math.max(...index_Array)
  var reportFormat = "";

  ScheduleRecurrenceList.forEach(recurrenceList => {
    maxid = maxid + 1
    if (UserPreference_response.timeFormatText !== "Time24HourFormat") {
      FormatedTime = moment(recurrenceList.hour, 'hh:mm A').add(recurrenceList.minute, 'minutes').format('hh:mm A')
    } else {
      FormatedTime = moment(recurrenceList.hour, 'HH:mm A').add(recurrenceList.minute, 'minutes').format('HH:mm A')
    }

    var ExcelText = "";
    if (recurrenceList.createPDF && recurrenceList.createExcel) {
	    ExcelText = recurrenceList.createFileAlways === true ? " - Create a new Excel file" : " - Reuse the same Excel file";
      reportFormat = label["ManageReportSchedule.lblPDFandExcel.Text"] + ExcelText;
    } else if (recurrenceList.createPDF) {
      reportFormat = label["SetupReportSchedule.lblCreatePDFFile.Text"];
    } else if (recurrenceList.createExcel) {
	    ExcelText = recurrenceList.createFileAlways ? " - Create a new Excel file" : recurrenceList.isFileCreated ? " - Reuse the same Excel file" : "";
      reportFormat = label["SetupReportSchedule.lblCreateExcelFile.Text"] + ExcelText;
    } else if(recurrenceList.createCSV){
        reportFormat = label["SetupReportSchedule.lblCreateCSVFile.Text"];
    } else {
      reportFormat = "-";
    }

    // weekly
    if (recurrenceList.interval === 'P1W') {
      let TempList11 = [], l_DaysOfWeekString = '';
      recurrenceList.daysOfWeek.forEach(days => {
        TempList11.push(label['EnumSetupReportSchedule.WeekDays.' + days + '.Text']);
      });
      if(TempList11.length){
        //Join the Array with comma, and replace the " and " instead of ", " between the last two items
        l_DaysOfWeekString = TempList11.join(", ").replace(/, ((?:.(?!, ))+)$/, ' and $1');
      }

      l_DaysOfWeekString = format(label['ManageReportSchedule.Weekly.Text'], l_DaysOfWeekString, '', FormatedTime);

      EffectiveDaysList.push({
        id: maxid,
        EffectiveDaysString: l_DaysOfWeekString,
        exportFormat: reportFormat,
        artifactId: recurrenceList.artifactId,
        createExcel: recurrenceList.createExcel,
        createFileAlways: recurrenceList.createFileAlways,
        createPDF: recurrenceList.createPDF,
        day: recurrenceList.day,
        daysOfWeek: recurrenceList.daysOfWeek,
        hour: recurrenceList.hour,
        interval: recurrenceList.interval,
        isFileCreated: recurrenceList.isFileCreated,
        key: recurrenceList.key,
        minute: recurrenceList.minute,
        modifier: recurrenceList.modifier,
        month: recurrenceList.month,
        nextSchedule: recurrenceList.nextSchedule,
        reportId: recurrenceList.reportId,
        reportScheduleId: recurrenceList.reportScheduleId,
        reportScheduleMappingId: recurrenceList.reportScheduleMappingId,
        calendarEntries: {
          "ReportCalendarId": 0,
          "ReportId": recurrenceList.reportId,
          "IsExclusion": false,
          "IsStartDateTime": false,
          "reportScheduleId": recurrenceList.reportScheduleId,
          "Offset": null,
          "range": {
            "from": new Date(),
            "timeSpan": "23:59:00",
            "to": new Date()
          }
        }
      })
    }

    // Monthly
    if (recurrenceList.interval === 'P1M') {
      var lM_EffectiveDaysString = "";
      if (recurrenceList.day != null) 
        lM_EffectiveDaysString = format(label['ManageReportSchedule.Monthly1.Text'], '', '', FormatedTime, '', recurrenceList.day);
      else if (recurrenceList.modifier === periodEnum.Last && recurrenceList.daysOfWeek.length === periodEnum.Last)
        lM_EffectiveDaysString = format(label['ManageReportSchedule.Monthly2.Text'], '', '', FormatedTime);
      else
        lM_EffectiveDaysString = format(label['ManageReportSchedule.Monthly3.Text'], week[recurrenceList.daysOfWeek[0]], '', FormatedTime, period[recurrenceList.modifier]);

      EffectiveDaysList.push({
        id: maxid,
        EffectiveDaysString: lM_EffectiveDaysString,
        exportFormat: reportFormat,
        artifactId: recurrenceList.artifactId,
        createExcel: recurrenceList.createExcel,
        createFileAlways: recurrenceList.createFileAlways,
        createPDF: recurrenceList.createPDF,
        day: recurrenceList.day,
        daysOfWeek: recurrenceList.daysOfWeek,
        hour: recurrenceList.hour,
        interval: recurrenceList.interval,
        isFileCreated: recurrenceList.isFileCreated,
        key: recurrenceList.key,
        minute: recurrenceList.minute,
        modifier: recurrenceList.modifier,
        month: recurrenceList.month,
        nextSchedule: recurrenceList.nextSchedule,
        reportId: recurrenceList.reportId,
        reportScheduleId: recurrenceList.reportScheduleId,
        reportScheduleMappingId: recurrenceList.reportScheduleMappingId,
        calendarEntries: {
          "ReportCalendarId": 0,
          "ReportId": recurrenceList.reportId,
          "IsExclusion": false,
          "IsStartDateTime": false,
          "reportScheduleId": recurrenceList.reportScheduleId,
          "Offset": null,
          "range": {
            "from": new Date(),
            "timeSpan": "23:59:00",
            "to": new Date()
          }
        }
      })
    }

    // Yearly
    if (recurrenceList.interval === 'P1Y') {
      var lY_EffectiveDaysString = "";
      if (recurrenceList.day != null)
        lY_EffectiveDaysString = format(label['ManageReportSchedule.Yearly1.Text'], '', month[recurrenceList.month - 1], FormatedTime, '', recurrenceList.day);
      else if (recurrenceList.modifier === periodEnum.Last && recurrenceList.daysOfWeek.length === periodEnum.Last)
        lY_EffectiveDaysString = format(label['ManageReportSchedule.Yearly2.Text'], '', '', FormatedTime);
      else
        lY_EffectiveDaysString = format(label['ManageReportSchedule.Yearly3.Text'], week[recurrenceList.daysOfWeek[0]], month[recurrenceList.month - 1], FormatedTime, period[recurrenceList.modifier]);

      EffectiveDaysList.push({
        id: maxid,
        EffectiveDaysString: lY_EffectiveDaysString,
        exportFormat: reportFormat,
        artifactId: recurrenceList.artifactId,
        createExcel: recurrenceList.createExcel,
        createFileAlways: recurrenceList.createFileAlways,
        createPDF: recurrenceList.createPDF,
        day: recurrenceList.day,
        daysOfWeek: recurrenceList.daysOfWeek,
        hour: recurrenceList.hour,
        interval: recurrenceList.interval,
        isFileCreated: recurrenceList.isFileCreated,
        key: recurrenceList.key,
        minute: recurrenceList.minute,
        modifier: recurrenceList.modifier,
        month: recurrenceList.month,
        nextSchedule: recurrenceList.nextSchedule,
        reportId: recurrenceList.reportId,
        reportScheduleId: recurrenceList.reportScheduleId,
        reportScheduleMappingId: recurrenceList.reportScheduleMappingId,
        calendarEntries: {
          "ReportCalendarId": 0,
          "ReportId": recurrenceList.reportId,
          "IsExclusion": false,
          "IsStartDateTime": false,
          "reportScheduleId": recurrenceList.reportScheduleId,
          "Offset": null,
          "range": {
            "from": new Date(),
            "timeSpan": "23:59:00",
            "to": new Date()
          }
        }
      })
    }

    // Daily or for Date Range
    if (recurrenceList.interval === 'P1D' && ScheduleReportList.calendarEntries.length > 0) {

      var l_calendarEntry = ScheduleReportList.calendarEntries.filter(x => x.reportScheduleId === recurrenceList.reportScheduleId);
      var now = new Date().toISOString("YYYY-MM-DDTHH:mm:ssZ");
      if(l_calendarEntry[0] !== undefined && l_calendarEntry[0] !== null ){
        var calendarEntry = l_calendarEntry[0];
        let fromDate = calendarEntry.from.split("T")[0];
        let nowDateValue = new Date(now.replace("T"," ").replace("Z",""))
        let toDate = '';
        let toDateValue = '';
        if (l_calendarEntry[0].range.to !== null) {
          toDate = calendarEntry.to.split("T")[0];
          toDateValue = new Date(calendarEntry.to.replace("T"," ").replace("Z",""))
        }
        // console.log("This is the toDateValue " + toDateValue)
        // console.log("This is the now date " + nowDateValue)
        var lD_EffectiveDaysString = "";

        if (fromDate === toDate) {
          var FDate = fromDate.split("-");
          if (nowDateValue <= toDateValue ) {
            lD_EffectiveDaysString = format(label['ManageReportSchedule.Daily.Text'], month[Number(FDate[1])-1] + ' ' + FDate[2] + ' , ' + FDate[0], '', FormatedTime);
          }
        } else {
          var lFDate = fromDate.split("-");
          if (l_calendarEntry[0].range.to !== null) {
            var TDate = toDate.split("-");
            if (nowDateValue <= toDateValue) {
            lD_EffectiveDaysString = format(label['ManageReportSchedule.DateRange.Text'], month[Number(lFDate[1])-1] + ' ' + lFDate[2] + ' , ' + lFDate[0], month[Number(TDate[1])-1] + ' ' + TDate[2] + ' , ' + TDate[0], FormatedTime);
            }
          }else{
            var lbl = label['ManageReportSchedule.DateRangeNoTo.Text'] && label['ManageReportSchedule.DateRangeNoTo.Text']  !== null ? label['ManageReportSchedule.DateRangeNoTo.Text'] : "Every day from {0} at {2}";
            lD_EffectiveDaysString = format(lbl, month[Number(lFDate[1])-1] + ' ' + lFDate[2] + ' , ' + lFDate[0],'', FormatedTime);
          }
        }

        if (lD_EffectiveDaysString !=="") {          
          EffectiveDaysList.push({
            id: maxid,
            EffectiveDaysString: lD_EffectiveDaysString,
            exportFormat: reportFormat,
            artifactId: recurrenceList.artifactId,
            createExcel: recurrenceList.createExcel,
            createFileAlways: recurrenceList.createFileAlways,
            createPDF: recurrenceList.createPDF,
            day: recurrenceList.day,
            daysOfWeek: recurrenceList.daysOfWeek,
            hour: recurrenceList.hour,
            interval: recurrenceList.interval,
            isFileCreated: recurrenceList.isFileCreated,
            key: recurrenceList.key,
            minute: recurrenceList.minute,
            modifier: recurrenceList.modifier,
            month: recurrenceList.month,
            nextSchedule: recurrenceList.nextSchedule,
            reportId: recurrenceList.reportId,
            reportScheduleId: recurrenceList.reportScheduleId,
            reportScheduleMappingId: recurrenceList.reportScheduleMappingId,
            calendarEntries: calendarEntry
          })
        }
      }
    }

  })
  return EffectiveDaysList;
}